import { Box, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { useCallback, useState } from 'react'
import { Animated, EasingFunction } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import {
  Colors,
  dateTimeMobileOnly,
  formatAMPM,
  getMonthName,
  numberToLocalString,
  roundOfToTwoDigits,
  roundOfToTwoDigits2,
} from '../../util/util'
import { CircleProgressAnimation } from './CircleProgressAnimation'
import { PaymentFlashAnimation } from './PaymentFlashAnimation'

export const StatusReceiverType = {
  success: 'success',
  error: 'error',
  failed: 'failed',
  pending: 'pending',
  default: 'default',
}

const getIconFromType = (type: string, amt: string, isRefund: boolean, payerName: string) => {
  let icon = 'TIMER',
    actionIcon = 'ARROW_RIGHT',
    amountText = 'Payment pending',
    color = 'ORANGE'

  switch (type) {
    case 'success':
      icon = 'StatusSuccess'
      amountText = isRefund ? `₹ ${amt} Refunded` : `Received ₹${amt}`
      color = '#00B259'
      break
    case 'error':
      icon = 'StatusError'
      amountText = isRefund ? `Refund failed of ₹ ${amt}` : 'Payment Failed'
      color = '#ED617F'
      break
    case 'failed':
      icon = 'StatusError'
      amountText = isRefund ? `Refund failed of ₹ ${amt}` : 'Payment Failed'
      color = '#ED617F'
      break
    case 'pending':
    case 'default':
      icon = 'StatusSuccess'
      amountText = 'Check status of your payment.'
      color = 'BLUE'
      break

    default:
      break
  }
  return { icon, actionIcon, amountText, color }
}

const iconStartValue = 152
const QrPaymentStatus = () => {
  const params: any = useRoute()?.params
  const { amount, isRefund, autoDismiss = false, txnId, data, type = 'error' } = params ?? {}
  const [status, setStatus] = useState(type)
  const [transaction, setTransaction] = useState(data)
  const [flashAnimated, setFlashAnimated] = useState(false)
  const [animateLogo] = useState<any>(new Animated.Value(0))
  const [animateCloseIcon] = useState<any>(new Animated.Value(0))
  const [animateMidContainer] = useState<any>(new Animated.Value(0))
  const [animateMidIcon] = useState<any>(new Animated.Value(0))
  const navigation = useNavigation()
  const response: any = transaction?.data?.transactionList?.[0] ?? {}
  const date = response?.transaction?.created ?? new Date().toString()
  let dateWithAmPm: any = dateTimeMobileOnly(date, false)

  dateWithAmPm = `${roundOfToTwoDigits(dateWithAmPm.getDate())} ${
    getMonthName[roundOfToTwoDigits2(dateWithAmPm.getMonth())]
  } ${dateWithAmPm.getFullYear()}, ${formatAMPM(dateWithAmPm)}`

  // const { checkStatus } = useStores((root) => ({
  //   checkStatus: root.transactions.checkStatus,
  // }))
  //const [checkTxnStatus, statusHandler] = useLazyApiData(checkStatus)

  // const redirectCondition = statusHandler.data?.status === 'success' || status === 'success'
  const payerName = response?.payer?.name
  const getProps = getIconFromType(transaction.status, numberToLocalString(Number(amount)), isRefund, payerName)

  console.log('params', params)
  console.log('payment data', data)
  console.log('payment response', response)
  console.log('payment payerName', payerName)

  // useEffect(() => {
  //   if (statusHandler.state === 'fulfilled') {
  //     if (statusHandler?.data) {
  //       setTransaction(statusHandler.data)
  //       setStatus(statusHandler.data?.status?.toLowerCase())
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [statusHandler.state])

  const onDismiss = () => {
    navigation.popTo('dashboard' as never)
  }

  const animateOpacity = animateMidContainer.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  })
  const transformMidContainer = animateMidContainer.interpolate({
    inputRange: [0, 1],
    outputRange: [42, 0],
  })

  const transformMidIcon = animateMidIcon.interpolate({
    inputRange: [0, 1],
    outputRange: [iconStartValue, 1],
  })
  const opacityMidIcon = animateMidIcon.interpolate({
    inputRange: [0, 1],
    outputRange: [0, 1],
  })
  const scaleMidIcon = animateMidIcon.interpolate({
    inputRange: [0, 1],
    outputRange: [0.8, 1],
  })
  const transformLogo = animateLogo.interpolate({
    inputRange: [0, 1],
    outputRange: [-91, 1],
  })
  const transformCloseIcon = animateCloseIcon.interpolate({
    inputRange: [0, 1],
    outputRange: [101, 1],
  })

  const easeOutBack: EasingFunction = (x: number): number => {
    const c1 = 1.70158
    const c3 = c1 + 1

    return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2)
  }

  const animateCloseIconFn = useCallback(() => {
    Animated.parallel(
      [
        Animated.timing(animateCloseIcon, {
          toValue: 1,
          // bounciness: 10,
          easing: easeOutBack,
          // delay: 100,
          useNativeDriver: true,
        }),
        Animated.timing(animateLogo, {
          toValue: 1,
          // bounciness: 10,
          easing: easeOutBack,
          // delay: 100,
          useNativeDriver: true,
        }),
        Animated.timing(animateMidIcon, {
          toValue: 1,
          delay: 100,
          duration: 500,
          easing: easeOutBack,
          // easing: Easing.linear,
          useNativeDriver: true,
        }),
        Animated.timing(animateMidContainer, {
          toValue: 1,
          //easing: Easing.linear,
          easing: easeOutBack,
          delay: 200,
          duration: 500,
          useNativeDriver: true,
        }),
      ],
      { stopTogether: false },
    ).start()
  }, [animateCloseIcon, animateLogo, animateMidContainer, animateMidIcon])

  let animateViewStyle = status === 'success'
  const callbackAnimation = () => {
    setFlashAnimated(true)
    if (animateViewStyle) {
      animateCloseIconFn()
    }
  }

  // const handleStatusCheck = () => {
  //   logEvent('btn_press', 'view qr payment details')
  //   if (redirectCondition) {
  //     navigation.navigate(
  //       Routes.TRANSACTIONS_DETAILS as never,
  //       {
  //         transactionId: txnId,
  //         path: Routes.TRANSACTIONS,
  //       } as never,
  //     )
  //   } else {
  //     checkTxnStatus(txnId)
  //   }
  // }

  // useEffect(() => {
  //   if (flashAnimated) {
  //     animateCloseIconFn()
  //   }
  // }, [flashAnimated, animateCloseIconFn])

  if (!StatusReceiverType.hasOwnProperty(status)) {
    return null
  } else if (!flashAnimated && animateViewStyle) {
    return (
      <ModBox backgroundColor={'WHITE'} flex={1} align="center" justify="center">
        <PaymentFlashAnimation callback={callbackAnimation} />
      </ModBox>
    )
  } else {
    return (
      <Box backgroundColor={'WHITE'} flex={1} flexDirection="column" justify="space-around" alignItems="center">
        <ViewComp animateViewStyle={animateViewStyle} style={[{ transform: [{ translateY: transformLogo }] }]}>
          <Box justify="center" align="center">
            <SvgImage imageName={'JioPayLightDarkBg'} textColor={'#000'} color={Colors.PRIMARY} />
          </Box>
        </ViewComp>
        <Box>
          <ViewComp
            animateViewStyle={animateViewStyle}
            style={[
              {
                opacity: opacityMidIcon,
                transform: [{ translateY: transformMidIcon }, { scale: scaleMidIcon }, { perspective: 1000 }],
              },
            ]}>
            <Box justify="center" align="center">
              <SvgImage imageName={getProps.icon} color={getProps.color} />
              <Spacer size={20} direction="vertical" />
            </Box>
          </ViewComp>
          <ViewComp
            animateViewStyle={animateViewStyle}
            style={{ transform: [{ translateY: transformMidContainer }], opacity: animateOpacity }}>
            <Box justify="center" align="center">
              <Text fontSize={32} color={Colors.BLACK_14} fontFamily={'JioType-Black'} weight={'dense'}>
                {'₹' + numberToLocalString(amount)}
              </Text>
              <Spacer size={10} direction="vertical" />

              <Text color={Colors.BLACK_14} lineHeight={22} type="body" fontSize={14} fontFamily={'JioType-Bold'}>
                {getProps?.amountText}
              </Text>
              <Text type={'caption'} lineHeight={16} color={Colors.PRIMARY_GREY} fontFamily={'JioType-Medium'}>
                {dateWithAmPm}
              </Text>

              {/* <ModBox show={status === 'success' || status === 'error'}>
                <Spacer size={20} direction="vertical" />
                <Box
                  ph={20}
                  justify="center"
                  align="center"
                  flexDirection={'row'}
                  testID="check-qr-status"
                  onPress={handleStatusCheck}
                  underlayColor={'TRANSPARENT'}
                  bg={'TRANSPARENT'}
                  borderWidth={1}
                  borderColor={'PRIMARY'}
                  borderRadius={30}
                  height={40}>
                  <Text fontFamily={'JioType-Bold'} fontSize={12} color={'PRIMARY'}>
                    View details
                  </Text>
                  <Spacer size={10} direction="horizontal" />
                  <SvgImage imageName="IconArrowNext" color={Colors.PRIMARY} />
                </Box>
              </ModBox> */}
            </Box>
          </ViewComp>
        </Box>
        <ViewComp animateViewStyle={animateViewStyle} style={{ transform: [{ translateY: transformCloseIcon }] }}>
          <Box alignItems={'center'} justifyContent="center" marginBottom={20} marginTop={5}>
            <CircleProgressAnimation
              autoDismiss={autoDismiss ?? animateViewStyle}
              autoCloseInSecs={11}
              onClick={onDismiss}
            />
            <Spacer size={80} direction="vertical" />
          </Box>
        </ViewComp>
      </Box>
    )
  }
}

const ViewComp = (props: any) => {
  //console.log('props', props)
  const { animateViewStyle } = props
  return (
    <>
      {animateViewStyle ? (
        <Animated.View style={props?.style}>{props?.children}</Animated.View>
      ) : (
        <>{props?.children}</>
      )}
    </>
  )
}

export default QrPaymentStatus
